/**
 * The one line to show a person when a request fails.
 *
 * Never render backend prose or exception messages. Only explicitly recognized response
 * codes select app-authored guidance; everything else uses the caller's fixed fallback.
 */
export const TOO_MANY_REQUESTS_MESSAGE =
  'Too many requests in a short time. Please wait a minute and try again.';
export const ATTACHMENT_REUPLOAD_MESSAGE =
  'Your attachments could not be verified. Please try submitting again to upload the files again.';

export function requestErrorMessage(err, fallback) {
  if (err?.response?.status === 429) return TOO_MANY_REQUESTS_MESSAGE;
  if (err?.response?.status === 400 && err?.response?.data?.code === 'IVR_ATTACHMENT_REUPLOAD_REQUIRED') {
    return ATTACHMENT_REUPLOAD_MESSAGE;
  }
  return fallback;
}
